import { useEffect, useState } from 'react';
import { HorizontalLinearStepper } from '@wajeez-web/components/mui';
import { useQuery } from '@wajeez-web/components/helpers';
import { useParams, useNavigate } from 'react-router-dom';
import {
  CollectionComponetTypesActions,
  ComponentTypesActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';

import { ComponentComponentTypeForm } from '../components/ComponentComponentTypeForm';
import { ComponentForm } from '../components/ComponentForm';
import { CollectionComponentForm } from '../components/CollectionComponentForm';
import { CollectionComponentCollectionComponentTypeForm } from '../components/CollectionComponentCollectionComponentTypeForm';

export const CreateCollectionComponentsCollectionComponentPage = () => {
  const navigate = useNavigate();

  const query = useQuery();

  const contentDispatch = useContentDispatch();

  const [stepperCurrentStepIndex, setStepperCurrentStepIndex] =
    useState<number>(0);
  const [typeId, setTypeId] = useState<string | undefined>(
    query.get('typeId') ? (query.get('typeId') as string) : undefined
  );

  const collectionComponentTypesLookups = useContentSelector(
    ({ collectionComponentTypes }) =>
      collectionComponentTypes.collectionComponentTypesLookups
  );

  useEffect(() => {
    contentDispatch(
      CollectionComponetTypesActions.getCollectionComponentTypesLookupsAsync()
    );
  }, [contentDispatch]);

  useEffect(() => {
    window.history.replaceState(
      null,
      '',
      `/collection-components/new?typeId=${typeId || ''}`
    );

    if (typeId) {
      setStepperCurrentStepIndex(1);
    }
  }, [typeId]);

  const renderStepperStepContent = () => {
    switch (stepperCurrentStepIndex) {
      case 0:
        return (
          <CollectionComponentCollectionComponentTypeForm
            onSubmit={(body) => {
              setTypeId(body.typeId);
            }}
            onAddButtonClick={() => {
              navigate(`/collection-components/new/types/new`);
            }}
            collectionComponentTypesLookups={collectionComponentTypesLookups}
          />
        );
      case 1:
        return (
          <CollectionComponentForm
            type="Create"
            onSubmit={() => {
              navigate(`/collection-components`);
            }}
            onCancel={() => {
              navigate(`/collection-components`);
            }}
            collectionComponentTypeId={Number(typeId)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="py-10 px-4">
      <div className="w-1/2 mx-auto">
        <HorizontalLinearStepper
          steps={[
            { id: '1', text: 'Choose type', isOptional: false },
            { id: '2', text: 'Create collection component', isOptional: false },
          ]}
          currentStepIndex={stepperCurrentStepIndex}
        />
      </div>
      <div className="mt-6">{renderStepperStepContent()}</div>
    </div>
  );
};
